import { Component, OnInit } from '@angular/core';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { ProductBatchState } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductBatchStatesEditComponent } from './product-batch-states-edit/product-batch-states-edit.component';
import { ProductBatchStatesAddComponent } from './product-batch-states-add/product-batch-states-add.component';

@Component({
    selector: 'app-product-batch-states',
    templateUrl: './product-batch-states.component.html',
    styleUrl: './product-batch-states.component.sass',
    standalone: false
})
export class ProductBatchStatesComponent implements OnInit {

  configuration?: IGenericCrudConfiguration<ProductBatchState>;


  constructor(private api: MasterApiService) { }

  async ngOnInit(): Promise<void> {
    this.configuration = {
      resource: this.api.resources.product.productBatchStates,
      entityFields: {
        name: { isLink: true },
        color: { cellTemplate: 'hexColorSwatchCellTpl', dataType: 'shortstring' },
        excludeFromStockForecast: {},
        excludeFromValuedInventory: {},
        isBlockedForOperations: {},
      },
      editComponent: ProductBatchStatesEditComponent,
      createComponent: ProductBatchStatesAddComponent,
    };
  }
}
